import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import Home from "@/pages/Home";
import Checkout from "@/pages/Checkout";
import OrderDetail from "@/pages/OrderDetail";
import MyOrders from "@/pages/MyOrders";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminOrders from "@/admin/AdminOrders";
import AdminOrderDetail from "@/admin/AdminOrderDetail";
import AdminProducts from "@/admin/AdminProducts";
import AdminSlots from "@/admin/AdminSlots";
import AdminAreas from "@/admin/AdminAreas";
import AdminSettings from "@/admin/AdminSettings";
import AdminBanners from "@/admin/AdminBanners";
import AdminPrepList from "@/admin/AdminPrepList";
import AdminPackingSlips from "@/admin/AdminPackingSlips";
import AdminRouteSheet from "@/admin/AdminRouteSheet";
import AdminSalesReport from "@/admin/AdminSalesReport";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/orders" element={<MyOrders />} />
      <Route path="/orders/:id" element={<OrderDetail />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="orders/:id" element={<AdminOrderDetail />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="slots" element={<AdminSlots />} />
        <Route path="areas" element={<AdminAreas />} />
        <Route path="prep" element={<AdminPrepList />} />
        <Route path="slips" element={<AdminPackingSlips />} />
        <Route path="routes" element={<AdminRouteSheet />} />
        <Route path="sales" element={<AdminSalesReport />} />
        <Route path="banners" element={<AdminBanners />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <StoreProvider>
        <AppRouter />
        <Toaster position="top-center" richColors closeButton />
      </StoreProvider>
    </BrowserRouter>
  );
}
